import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';

// Fix for default marker icons in React Leaflet with Webpack
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});

// Using a custom gold icon for a premium look
const customIcon = new L.Icon({
  iconUrl: 'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-gold.png',
  shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png',
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41]
});

const MapWrapper = styled.div`
  width: 100%;
  height: 600px;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
  margin: 40px 0;
  border: 1px solid rgba(0, 0, 0, 0.05);
  position: relative;
  z-index: 1; /* Keep below fixed header */

  .leaflet-container {
    width: 100%;
    height: 100%;
    background: #1a1a1a;
  }
  
  .leaflet-popup-content-wrapper {
    background: rgba(255, 255, 255, 0.98);
    backdrop-filter: blur(10px);
    color: #2c2c2c;
    border-radius: 12px;
    border: 1px solid rgba(0, 0, 0, 0.1);
    box-shadow: 0 10px 25px rgba(0,0,0,0.15);
  }

  .leaflet-popup-tip {
    background: rgba(255, 255, 255, 0.98);
  }

  .leaflet-popup-content {
    margin: 15px 20px;
    
    h3 {
      color: #2B4B8C;
      margin: 0 0 10px 0;
      font-size: 1.2rem;
      border-bottom: 1px solid rgba(0, 0, 0, 0.08);
      padding-bottom: 8px;
    }
    
    ul {
      list-style: none;
      padding: 0;
      margin: 0;
      
      li {
        margin-bottom: 6px;
        font-size: 0.95rem;
        display: flex;
        align-items: center;
        gap: 8px;
        color: #495057;
        
        &::before {
          content: '•';
          color: #3B82C4;
        }
      }
    }
  }
`;

const locations = [
  {
    name: 'Şanlıurfa (Merkez)',
    position: [37.1674, 38.7955],
    facilities: ['1 Çimento Fabrikası', '3 Beton Santrali', 'Kalker Ocağı', 'Lojistik Merkezi']
  },
  {
    name: 'Mardin',
    position: [37.3122, 40.7360],
    facilities: ['1 Çimento Fabrikası']
  },
  {
    name: 'Niğde',
    position: [37.9698, 34.6766],
    facilities: ['1 Çimento Fabrikası']
  },
  {
    name: 'Hatay',
    position: [36.2023, 36.1613],
    facilities: ['5 Beton Santrali']
  },
  {
    name: 'Kilis',
    position: [36.7161, 37.1150],
    facilities: ['2 Beton Santrali']
  },
  {
    name: 'Rakka (Suriye)',
    position: [35.9500, 39.0167],
    facilities: ['1 Beton Santrali', '1 Alçı Fabrikası']
  },
  {
    name: 'Halep (Suriye)',
    position: [36.2021, 37.1343],
    facilities: ['1 Çimento Fabrikası']
  }
];

const LocationsMap = () => {
  return (
    <MapWrapper>
      <MapContainer 
        center={[36.5, 39.5]} 
        zoom={6} 
        scrollWheelZoom={false}
      >
        <TileLayer
          url="https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png"
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        />
        {locations.map((loc, index) => (
          <Marker key={index} position={loc.position} icon={customIcon}>
            <Popup>
              <h3>{loc.name}</h3>
              <ul>
                {loc.facilities.map((fac, i) => (
                  <li key={i}>{fac}</li>
                ))}
              </ul>
            </Popup>
          </Marker>
        ))}
      </MapContainer>
    </MapWrapper>
  );
};

export default LocationsMap;
